"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("core-js/modules/es6.array.sort");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _styles = require("@material-ui/core/styles");

var _colors = require("../../theme/colors");

var _Input = _interopRequireDefault(require("../Input"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _styles2 = require("../Select/shared/styles");

var _MultiControl = _interopRequireDefault(require("../Select/shared/MultiControl"));

var _Group = _interopRequireDefault(require("../Select/shared/Group"));

var _GroupHeading = _interopRequireDefault(require("../Select/shared/GroupHeading"));

var _Menu2 = _interopRequireDefault(require("../Select/shared/Menu"));

var _VirtualMultiMenuList = _interopRequireDefault(require("../Select/shared/VirtualMultiMenuList"));

var _LoadingMessage = _interopRequireDefault(require("../Select/shared/LoadingMessage"));

var _MultiMenuList = _interopRequireDefault(require("../Select/shared/MultiMenuList"));

var _MultiValue = _interopRequireDefault(require("../Select/shared/MultiValue"));

var _NoOptionMessage = _interopRequireDefault(require("../Select/shared/NoOptionMessage"));

var _Option = _interopRequireDefault(require("../Select/shared/Option"));

var _Placeholder = _interopRequireDefault(require("../Select/shared/Placeholder"));

var _SingleValue = _interopRequireDefault(require("../Select/shared/SingleValue"));

var _ValueContainer = _interopRequireDefault(require("../Select/shared/ValueContainer")); // component overrides


var noOptionsMessage = function noOptionsMessage() {
  return 'No results found.';
};

var componentOverrides = function componentOverrides() {
  return {
    Control: _MultiControl["default"],
    DropdownIndicator: null,
    Group: _Group["default"],
    GroupHeading: _GroupHeading["default"],
    IndicatorSeparator: null,
    LoadingMessage: _LoadingMessage["default"],
    Menu: _Menu2["default"],
    MenuList: _MultiMenuList["default"],
    MultiValue: _MultiValue["default"],
    NoOptionsMessage: _NoOptionMessage["default"],
    Option: _Option["default"],
    Placeholder: _Placeholder["default"],
    SingleValue: _SingleValue["default"],
    ValueContainer: _ValueContainer["default"]
  };
};

var SelectMulti =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(SelectMulti, _React$Component);

  function SelectMulti(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectMulti);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SelectMulti).call(this, props));
    _this.childRef = _react["default"].createRef();
    _this.state = {
      dropdownIsOpen: props.variant === 'withMenu',
      inputValue: '',
      popoverAnchor: null,
      viewSelectedEnabled: false
    };
    _this.handlePopoverOpen = _this.handlePopoverOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePopoverClose = _this.handlePopoverClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectAll = _this.handleSelectAll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleViewSelected = _this.handleViewSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.filterOptions = _this.filterOptions.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSearchInputChange = _this.handleSearchInputChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SelectMulti, [{
    key: "handleSearchInputChange",
    value: function handleSearchInputChange(typedValue, internalEvent) {
      // don't clear out searched value when selecting an item
      if (internalEvent.action !== 'set-value') {
        this.setState({
          inputValue: typedValue
        });
      } // return typedValue;

    }
  }, {
    key: "handlePopoverOpen",
    value: function handlePopoverOpen() {
      var isDisabled = this.props.isDisabled;

      if (!isDisabled) {
        this.setState({
          popoverAnchor: this.childRef
        });
      }
    }
  }, {
    key: "handlePopoverClose",
    value: function handlePopoverClose() {
      this.setState({
        popoverAnchor: null
      });
    }
  }, {
    key: "getLibraryComponent",
    value: function getLibraryComponent(isAsync) {
      var component = _reactSelect["default"];

      if (isAsync) {
        component = _reactSelect.Async;
      }

      return component;
    }
  }, {
    key: "handleSelectAll",
    value: function handleSelectAll(isSelected, optionsWhenToggled) {
      if (isSelected === true) {
        // this.setState({ value: });
        this.handleChange(optionsWhenToggled.map(function (row) {
          return row.props.data;
        }));
      } else {
        // also remove view selected when deselecting all from a view-selected state
        this.handleChange([]);
        this.setState({
          viewSelectedEnabled: false
        });
      }
    }
  }, {
    key: "handleViewSelected",
    value: function handleViewSelected(viewSelectedEnabled) {
      this.setState({
        viewSelectedEnabled: viewSelectedEnabled
      });
    }
  }, {
    key: "buildInputDisplay",
    value: function buildInputDisplay(value) {
      var output;

      if (value && value.length > 0) {
        var valueDisplays = value.map(function (option) {
          return option.label;
        });
        output = "(".concat(value.length, ") ").concat(valueDisplays.join(', '));
      }

      return output;
    }
  }, {
    key: "filterOptions",
    value: function filterOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var filtered = (0, _toConsumableArray2["default"])(options);
      var value = this.props.value;
      var viewSelectedEnabled = this.state.viewSelectedEnabled;
      var selectedValues = value ? value.map(function (row) {
        return row.value;
      }) : [];

      if (viewSelectedEnabled) {
        filtered = filtered.filter(function (row) {
          var isMatch = false;

          if (selectedValues.indexOf(row.value) > -1) {
            isMatch = true;
          }

          return isMatch;
        });
      }

      var inputValue = this.state.inputValue; // Show exact match first

      filtered.sort(function (rowA, rowB) {
        if (rowA.label.toLowerCase() === inputValue.toLowerCase()) {
          return -1;
        }

        if (rowB.label.toLowerCase() === inputValue.toLowerCase()) {
          return 1;
        }

        if (rowA.label < rowB.label) {
          return -1;
        }

        if (rowA.label > rowB.label) {
          return 1;
        }

        return 0;
      });
      return filtered;
    }
  }, {
    key: "handleChange",
    value: function handleChange(newVal) {
      var onChange = this.props.onChange;
      onChange(newVal);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this; // eslint-disable-next-line react/prop-types


      var _this$props = this.props,
          classes = _this$props.classes,
          id = _this$props.id,
          isAsync = _this$props.isAsync,
          isDisabled = _this$props.isDisabled,
          inputProps = _this$props.inputProps,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          renderVirtual = _this$props.renderVirtual,
          searchPlaceholder = _this$props.searchPlaceholder,
          selectRef = _this$props.selectRef,
          value = _this$props.value,
          variant = _this$props.variant,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["classes", "id", "isAsync", "isDisabled", "inputProps", "options", "placeholder", "renderVirtual", "searchPlaceholder", "selectRef", "value", "variant"]);
      var _this$state = this.state,
          popoverAnchor = _this$state.popoverAnchor,
          dropdownIsOpen = _this$state.dropdownIsOpen,
          inputValue = _this$state.inputValue;
      var textFieldProps = {
        InputLabelProps: {
          classes: {
            error: classes.error,
            root: classes.inputLabel
          },
          shrink: true
        }
      };
      var SelectComponent = this.getLibraryComponent(isAsync);

      var applyTheme = function applyTheme(theme) {
        return (0, _objectSpread2["default"])({}, theme, {
          colors: (0, _objectSpread2["default"])({}, theme.colors, {
            primary: _colors.opacity.primary[500][14],
            primary25: _colors.opacity.black[8],
            primary50: _colors.opacity.primary[500][14],
            primary75: _colors.opacity.primary[500][14]
          })
        });
      };

      var filteredOptions = this.filterOptions(options);
      var inputDisplayValue = this.buildInputDisplay(value) || placeholder;
      var overrides = componentOverrides();
      var withMenu = variant === 'withMenu';

      if (renderVirtual === true) {
        overrides.MenuList = _VirtualMultiMenuList["default"];
      }

      var ActualSelect = _react["default"].createElement(SelectComponent, (0, _extends2["default"])({
        ref: selectRef
      }, rest, {
        autoFocus: withMenu,
        onFocus: function onFocus() {
          if (!withMenu) {
            _this2.setState({
              dropdownIsOpen: true
            });
          }
        },
        onBlur: function onBlur() {
          if (!withMenu) {
            _this2.setState({
              dropdownIsOpen: false
            });
          }
        },
        automationid: "".concat(id, "-select"),
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        defaultOptions: [],
        classes: classes,
        components: overrides,
        controlShouldRenderValue: false,
        closeMenuOnSelect: false,
        filterOption: (0, _reactSelect.createFilter)({
          ignoreAccents: false
        }),
        handleSelectAll: this.handleSelectAll,
        handleViewSelected: this.handleViewSelected,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: true,
        menuIsOpen: dropdownIsOpen,
        noOptionsMessage: noOptionsMessage,
        onInputChange: this.handleSearchInputChange,
        inputValue: inputValue,
        onSelectResetsInput: false,
        onBlurResetsInput: false,
        options: filteredOptions,
        placeholder: searchPlaceholder || 'Type in to search',
        styles: _styles2.customStyles,
        textFieldProps: textFieldProps,
        theme: applyTheme,
        value: value
      }));

      var WithMenu = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Input["default"], {
        automationid: "".concat(id, "-input"),
        className: classes.input,
        disabled: !!isDisabled,
        value: inputDisplayValue,
        readOnly: true,
        onClick: this.handlePopoverOpen,
        disableUnderline: false,
        ref: this.childRef
      }), !!isDisabled === false && _react["default"].createElement(_Menu["default"], {
        className: classes.menu,
        disablePortal: true,
        open: Boolean(popoverAnchor),
        onClose: this.handlePopoverClose
      }, ActualSelect));

      return _react["default"].createElement("div", {
        automationid: "".concat(id),
        style: {
          position: 'relative'
        }
      }, withMenu ? WithMenu : ActualSelect);
    }
  }]);
  return SelectMulti;
}(_react["default"].Component);

SelectMulti.defaultProps = {
  variant: 'withMenu'
};
SelectMulti.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object.isRequired,

  /**
   * The id of the `input` element.
   */
  id: _propTypes["default"].string.isRequired,

  /**
   * Additional props to apply to the inputElement
   */
  inputProps: _propTypes["default"].object,

  /**
   * If `true`, the select will load options asynchronously when searching.
   * Use in concert with loadOptions prop.
   */
  isAsync: _propTypes["default"].bool,

  /**
   * If `true`, the select will be disabled.
   */
  isDisabled: _propTypes["default"].bool,

  /**
   * The function used to load options when `isAsync` is set to `true`.
   * Should return a promise with filtered results.
   */
  loadOptions: _propTypes["default"].func,

  /**
   * Callback fired when the state is changed.
   */
  onChange: _propTypes["default"].func,

  /**
   * options to be displayed for the options of the select
   */
  options: _propTypes["default"].array,

  /**
   * the ghost text displayed in the input before a value is selected
   */
  placeholder: _propTypes["default"].node,

  /**
   * If `true`, the component will render list options virtually.
   * Useful for large datasets. See [react-window](https://www.npmjs.com/package/react-window).
   */
  renderVirtual: _propTypes["default"].bool,

  /**
   * If provided, will provide a ref to the searchable input component
   */
  searchInputRef: _propTypes["default"].object,

  /**
   * the ghost text displayed in the menu's searchbox
   */
  searchPlaceholder: _propTypes["default"].node,
  theme: _propTypes["default"].object,

  /**
   * The value of the component.
   */
  value: _propTypes["default"].array.isRequired,

  /**
   * Which variant to use, available options: `standalone`, `withMenu` (default)
   */
  variant: _propTypes["default"].string
} : {};

var _default = (0, _styles.withStyles)(_styles2.styles, {
  withTheme: true
})(SelectMulti);

exports["default"] = _default;